export default __webpack_public_path__ + "static/media/BankPhn.b69c179b.svg";